import React from "react";
import ModulesChartComponent from "./modules-chart.component";

const ModulesSwapContentComponent = ({ type }) => {
  return <>{type === "CHART" && <ModulesChartComponent />}</>;
};

export default ModulesSwapContentComponent;
